import { EditOutlined } from '@ant-design/icons'
import { useProfile } from 'context/ProfileProvider'
import PropTypes from 'prop-types'

function EditIcon({ onClick, yPosition }) {
  const { hasPermission } = useProfile()
  const verticalPositioning = typeof yPosition === 'number' ? { top: `${yPosition * 6}em` } : {}
  return (
    hasPermission('MATRIX_CAN_EDIT_MATRIX') && (
      <div
        className="edit-icon"
        onClick={onClick}
        onKeyUp={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick?.(event)
          }
        }}
        role="button"
        tabIndex={0}
        style={verticalPositioning}
      >
        <EditOutlined />
      </div>
    )
  )
}

EditIcon.propTypes = {
  onClick: PropTypes.func,
  yPosition: PropTypes.number,
}

export default EditIcon
